import {call, put} from "typed-redux-saga";
import {Api} from "modules/utils";
import {
	requestPlayersFailed,
	requestPlayersSuccess,
	requestSinglePlayerStats,
	requestSinglePlayerStatsSuccess,
	singlePlayerStatsClear,
} from "modules/actions";
import {SagaIterator} from "redux-saga";

export const requestPlayersSaga = function* () {
	try {
		const result = yield* call(Api.JSON.players);
		yield* put(requestPlayersSuccess(result));
	} catch (err) {
		const {message} = err as Error;
		yield* put(requestPlayersFailed(message));
	}
};

export const requestSinglePlayerStatsSaga = function* ({
	payload,
}: ReturnType<typeof requestSinglePlayerStats>): SagaIterator {
	try {
		yield* put(singlePlayerStatsClear());
		const result = yield* call(Api.JSON.statPerPlayer, payload);

		if (Array.isArray(result)) {
			yield* put(requestSinglePlayerStatsSuccess(result));
		} else {
			yield* put(singlePlayerStatsClear());
		}
	} catch (e) {
		yield* put(singlePlayerStatsClear());
	}
};
